import request from '@/utils/request.js'

/**
 * 订单电子保单
 * @param params
 * @returns {AxiosPromise}
 */
export function addInsurance(params) {
    return request({
        url: '/operateService/api/app/insurance/addInsuranceChit',
        method: 'post',
        data: params
    })
}

/**
 * 电子保单回调
 * @param params
 * @returns {AxiosPromise}
 */
export function addInsuranceChit(params) {
    return request({
        url: '/operateService/api/insurance/addInsuranceChit',
        method: 'post',
        data: params
    })
}
